<nb-card style="width: 100%" [class.card-force-border]="PlanView">
  <nb-card-body [formGroup]="DayForm" style="width: 100%">
    <div class="row">
      <div class="col-lg-8 col-md-12 FramePadding">
        <div class="d-flex flex-column">
          <div>
            <div *ngIf="!PlanView" [hidden]="HidePlanName">
              <div>
                <ul>
                  <li>
                    Day
                    <div i18n="@@DayName" class="label col-form-label">
                      Day Name
                    </div>
                  </li>
                  <li style="width: 1100px">
                    <input formControlName="DayName" nbInput type="text" fullWidth shape="semi-round"
                      i18n-placeholder="@@DayName" placeholder="Day Name" (change)="NameChange($event)"
                      [attr.disabled]="PlanView ? true : null" />
                    <ngx-validation-message i18n-label="@@DayName" label="Day Name"
                      [showMinLength]="DayName?.hasError('minlength')" [showMaxLength]="DayName?.hasError('maxlength')"
                      [showRequired]="
                        DayName?.errors?.required && DayName.touched
                      " minLength="5" maxLength="50">
                    </ngx-validation-message>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Assign to week days -->
            <ul class="basic_list_informations row">
              <li i18n="@@AssignToWeekDays" class="GeneralLabel2 plan-day-assign-week-days col-12">
                Assigned week days
              </li>
              <li class="col pt-1">
                <day-of-week-checker formControlName="assignWeekDays" [readonly]="PlanView"
                  [attr.disabled]="PlanView ? true : null" (change)="onAssignWeekDaysChagne($event)">
                </day-of-week-checker>
              </li>
              <li class="col" *ngIf="PlanView">
                <app-fitness-workout style="float: right;" [PlanDay]="Day" [PatientID]="PatientID"
                  [IsPreferredUnitImperial]="IsPreferredUnitImperial"></app-fitness-workout>
              </li>
            </ul>
            <!-- Notes -->
            <ul class="basic_list_informations row">
              <li i18n="@@Notes" class="GeneralLabel2 plan-day-notes col-12">
                Notes
              </li>
              <li class="plan-day-notes-editor col pt-1">
                <smart-edit formControlName="DayNotes" i18n-placeholder="@@Notes" placeholder="Notes"
                  [readonly]="PlanView" [IsMultiLine]="true" [MaxLength]="FormConstants.NotesMaxLength"
                  [(MultiLineHeight)]="DayNotesHeight" [attr.disabled]="PlanView ? true : null"
                  (keyup)="NotesChange($event)">
                </smart-edit>

                <ngx-validation-message i18n-label="@@Notes" label="Notes"
                  [showMaxLength]="DayNotes?.hasError('maxlength')" [maxLength]="FormConstants.NotesMaxLength">
                </ngx-validation-message>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="graph_adjustments_item col-lg-4 col-md-12 FramePadding">
        <div class="total-metrics-container">
          <app-day-fitness-summary #DayFitnessSummaryView class="{{ PlanView ? 'plan-view' : '' }}"
            [Exercises]="DayExercises" [Reps]="DayReps" [Minutes]="DayMinutes" [PlanDays]="PlanDays" [ActiveDay]="Day">
          </app-day-fitness-summary>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div *ngFor="let block of Day.blocks; let i = index">


          <div class="remove-block-wrapper">
            <div class="remove-block-action" style="z-index: 100">
              <button nbButton class="btn-remove-meal" alt="Copy" (click)="Copy(block)" [hidden]="PlanView"
                style="padding: 0px !important">
                <nb-icon icon="copy-outline" alt="Copy"></nb-icon>
              </button>

              <button nbButton alt="Paste" class="btn-remove-meal" (click)="Paste(block)"
                [hidden]="PlanView || !HasClipboard()" style="padding: 0px !important">
                <nb-icon icon="clipboard-outline" alt="Paste"></nb-icon>
              </button>

              <div *ngIf="block.blockType == 0 || block.blockType == 1">
                <button nbButton class="btn-remove-meal" (click)="OrderUp(block)" [hidden]="PlanView || !CanRemoveBlock"
                  style="padding: 0px !important">
                  <nb-icon icon="arrow-upward-outline"></nb-icon>
                </button>

                <button nbButton class="btn-remove-meal" (click)="OrderDown(block)"
                  [hidden]="PlanView || !CanRemoveBlock" style="padding: 0px !important">
                  <nb-icon icon="arrow-downward-outline"></nb-icon>
                </button>
              </div>

              <button nbButton class="btn-remove-meal" (click)="RemoveBlock(block)"
                [hidden]="PlanView || !CanRemoveBlock" style="padding: 0px !important">
                <nb-icon icon="trash-2-outline"></nb-icon>
              </button>
            </div>
          </div>

          <app-fitness-block #FitnessBlock [PatientID]="PatientID" [PatientName]="PatientName"
            [IsPreferredUnitImperial]="IsPreferredUnitImperial" [FitnessBlock]="block" [Index]="i" *ngIf="!PlanView"
            [ShowWarmup]="showWarmup(block)" [ShowCooldown]="showCooldown(block)"></app-fitness-block>
          <app-fitness-block-mobile #FitnessBlock [PatientID]="PatientID" [PatientName]="PatientName"
            [IsPreferredUnitImperial]="IsPreferredUnitImperial" [FitnessBlock]="block" [Index]="i" *ngIf="PlanView">
          </app-fitness-block-mobile>

          <div style="height: 10px"></div>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer [hidden]="PlanView || NewDayView">
    <div>
      <button i18n="@@Accept" nbButton type="submit" (click)="Accept()" class="btn-circle btn-xl btn-main btn-main"
        [disabled]="!DayForm.valid" [hidden]="!ShowSubmit">
        Accept
      </button>
      <button i18n="@@AddNewBlock" nbButton type="submit" (click)="NewBlock()"
        class="btn-circle btn-xl btn-main btn-circle btn-xl">
        Add New Block
      </button>
    </div>
  </nb-card-footer>

  <nb-card-footer [hidden]="!NewDayView || PlanView">
    <div>
      <button i18n="@@Accept" nbButton type="submit" (click)="Accept()" class="btn-circle btn-xl btn-main btn-main"
        [disabled]="!DayForm.valid" [hidden]="!ShowSubmit">
        Accept
      </button>
      <button i18n="@@AddNewBlock" nbButton type="submit" (click)="NewBlock()"
        class="btn-circle btn-xl btn-main btn-main">
        Add New Block
      </button>
    </div>
  </nb-card-footer>
</nb-card>